$(document).ready(function () {
	$('.video-block-video-icon').click(function () {
      $(this).css("display", "none");
      $(".video-block-video-poster").css("display", "none");
      // $('#homepage-intro-video')[0].play();
      // var video_id = "MQLDLmOMHV4"; // replace with your YouTube video ID
      // var iframe_url = "https://www.youtube.com/embed/" + video_id + "?autoplay=1"; // add autoplay parameter to the YouTube URL
      // var iframe = '<iframe width="100%" height="100%" src="' + iframe_url + '" frameborder="0" allowfullscreen></iframe>';
      // $("#homepage-intro-video").html(iframe);
	});

  $('.video-block-video-poster').click(function () {
      $(this).css("display", "none");
      $(".video-block-video-icon").css("display", "none");
      // $('#homepage-intro-video')[0].play();
	});

  	$('#about-page-first-video-play').click(function () {
      $(this).css("display", "none");
      $("#about-page-first-video-poster").css("display", "none");
	});

  	$('#about-page-first-video-poster').click(function () {
      $(this).css("display", "none");
      $("#about-page-first-video-play").css("display", "none");
	});

   	$('#about-page-second-video-play').click(function () {
      $(this).css("display", "none");
      $("#about-page-second-video-poster").css("display", "none");
	});

  	$('#about-page-second-video-poster').click(function () {
      $(this).css("display", "none");
      $("#about-page-second-video-play").css("display", "none");
	});

   // Get the modal and the button
  var modal = document.getElementById("video-modal");
  var button = document.getElementById("play-button");

  // Get the <video> element
  var video = document.getElementById("video-player");

  // When the user clicks on the button, open the modal
  button.onclick = function() {
    modal.style.display = "block";
    video.play();
  }

  // When the user clicks on <span> (x), close the modal
  var span = document.getElementsByClassName("close")[0];
  span.onclick = function() {
    modal.style.display = "none";
    video.pause();
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      video.pause();
    }
  }
  
});
